export default __webpack_public_path__ + "static/media/iconMenu_beef.1897849f.svg";